<div class="container">
  <div class="cycle-list">
    <div class="row">
      <div *ngFor="let c of cycles" class="col-s-12 col-md-6 card-wrapper">
        <mat-card appearance="outlined" class="testClass">
          <mat-card-title>{{ c.name }}</mat-card-title>
          <mat-card-content>
            {{ c.description }}
            <br />
            <table style="font-size: 0.8rem">
              <tr>
                <th>Bewerbung</th>
                <td>{{ c.applicationStart | moment }} &nbsp;-</td>
                <td>{{ c.applicationEnd | moment }}</td>
              </tr>
              <tr>
                <th>Voting</th>
                <td>{{ c.votingStart | moment }} &nbsp;-</td>
                <td>{{ c.votingEnd | moment }}</td>
              </tr>
              <tr>
                <th>Feedback</th>
                <td colspan="2">{{ c.feedback | moment }}</td>
              </tr>
              <tr>
                <th>Pitch</th>
                <td colspan="2">{{ c.pitchDate | moment: 'date' }}</td>
              </tr>
              <tr>
                <th></th>
                <td colspan="2">in {{ c.location }}</td>
              </tr>
              <tr>
                <th>Veröffentlichung</th>
                <td>{{ c.publishStart | moment }} &nbsp;-</td>
              </tr>
            </table>
          </mat-card-content>
          <mat-card-actions class="icons" align="end" *minPrivilege="'FULL'">
            <a mat-button> <mat-icon>open_in_new</mat-icon>Produkte </a>
            <a mat-button> <mat-icon>open_in_new</mat-icon>Voting </a>
            <div style="flex-grow: 100"></div>
            <a mat-button class="edit" (click)="edit(c)"> <mat-icon>edit</mat-icon>Bearbeiten </a>
            <a mat-button class="delete" (click)="delete(c)"> <mat-icon>delete</mat-icon> Löschen </a>
          </mat-card-actions>
        </mat-card>
      </div>

      <markant-button *minPrivilege="'FULL'" (click)="add()" class="add-cycle" mat-fab color="primary">
        <mat-icon>add</mat-icon>
      </markant-button>
    </div>
  </div>
</div>
